import React from "react";

interface DownloadButtonProps {
  onClick: () => void;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({ onClick }) => {
  return (
    <button
      className="bg-gray-300 text-black py-2 px-4 rounded-md hover:bg-gray-500 focus:outline-none"
      onClick={onClick}
    >
      Download
    </button>
  );
};

export default DownloadButton;
